<template>
    <div class="freelancer-signup-step-welcome-to-malt__articles">
        <slot />
    </div>
</template>

<style lang="scss">
    .freelancer-signup-step-welcome-to-malt {
        &__articles {
            margin-right: var(--joy-core-spacing-8);

            & > *:first-child {
                padding-top: 0;
            }
        }
    }
</style>
